/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegistroRouteImport } from './routes/registro'
import { Route as ProgramaRouteImport } from './routes/programa'
import { Route as IndexRouteImport } from './routes/index'

const RegistroRoute = RegistroRouteImport.update({
  id: '/registro',
  path: '/registro',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramaRoute = ProgramaRouteImport.update({
  id: '/programa',
  path: '/programa',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/programa': typeof ProgramaRoute
  '/registro': typeof RegistroRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/programa': typeof ProgramaRoute
  '/registro': typeof RegistroRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/programa': typeof ProgramaRoute
  '/registro': typeof RegistroRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/programa' | '/registro'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/programa' | '/registro'
  id: '__root__' | '/' | '/programa' | '/registro'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProgramaRoute: typeof ProgramaRoute
  RegistroRoute: typeof RegistroRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/registro': {
      id: '/registro'
      path: '/registro'
      fullPath: '/registro'
      preLoaderRoute: typeof RegistroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programa': {
      id: '/programa'
      path: '/programa'
      fullPath: '/programa'
      preLoaderRoute: typeof ProgramaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProgramaRoute: ProgramaRoute,
  RegistroRoute: RegistroRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
